import React, { useState, useEffect } from "react";
import UserProfileComponent from "../UserProfileComponent";
import { ClearSessionItems } from "../../helper/appsession";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { setCompany } from "../../redux/companySlice";
import { useDispatch } from "react-redux";
import ChangeCompanyComponent from "../Shared/ChangeCompanyComponent";
import { ApplicationService } from "../../apis/apiServices/Application";
import { getReduxCompany } from "../../helper/sessionHelper";

export default function HeaderComponent() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const reduxCompany = useSelector((state) => state?.company?.data);
  const [appsLength, setAppsLenght] = useState(1)
  const [appListData, setAppListData] = useState([]);
  const [applicationsWithUserAccess, setApplicationsWithUserAccess] = useState({});



  const getAppLogo = (appId) => {
    let appLogo = "";
    appListData?.forEach((app) => {
      if (app?.id === appId) {
        appLogo = app?.logo;
      }
    })
    return appLogo;
  }

  const fetchAllApplicationsWithUserAccess = async () => {
    let body = {}
    body.userId = user?.userId;

    let response = await ApplicationService?.getAllApplicationsWithUserAccess(body)

    let applicationList = response?.isSuccess ? response?.data || [] : [];

    const appDictionaryById = applicationList?.reduce((dict, item) => {
      dict[item.id] = item;
      return dict;
    }, {});
    setAppsLenght(applicationList?.length)
    setAppListData(applicationList);
    setApplicationsWithUserAccess(appDictionaryById);

  }


  const handleLauncherLogin = (appUrl) => {
    let companyId = getReduxCompany()?.id || 0;
    const queryParams = new URLSearchParams({ refreshToken: user?.refreshToken, companyId: Number(companyId) }).toString();
    const fullUrl = `${appUrl}?${queryParams}`;
    window.location.href = fullUrl;
  };

  const isApplicationAssignedAndActive = (appId) => {
    if (appId === true) { return true; }
    if (appId === false) { return false; }

    let application = applicationsWithUserAccess?.[appId];
    return (application?.isActive && application?.isApplicationAssigned) ? true : false;
  }

  useEffect(() => { fetchAllApplicationsWithUserAccess() }, [getReduxCompany()?.id])

    const handleBackToVishwam = (appUrl) => {
      let companyId = getReduxCompany()?.id || 0;
      const queryParams = new URLSearchParams({ companyId: Number(companyId) }).toString();
  
      const fullUrl = `${appUrl}?${queryParams}`;
  
      // window.open(fullUrl, '_blank');
      window.location.href = fullUrl;
    };

  return (
    <>
      {/* <div className="flex-column justify-content-center align-items-center" /> */}
      <div className="top-bar-company">
         <ul className="navbar-nav" style={{ flexDirection: 'row', alignItems: 'center' }}>
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item">
            <h3 className="pagetitle mb-0" id="pageTitle"></h3>
          </li>
        </ul>
        <span
          className="nav-link"
          // data-widget="fullscreen"
          role="button"
          style={{ padding: "0px", marginTop: "5px" }}
        >
          {/* <i className="fas fa-expand-arrows-alt" /> */}
          <img
            //src={`./assets/img/Company/${reduxCompany?.id}/company-logo.png`}
            src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + reduxCompany?.companyLogoPath}`}
            alt=""
            className="brand-image"
            height="35px"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "./assets/img/Company/1/default-company-logo.png"; // fallback
            }}
          />
          {/* <span className="company-code" style={{fontWeight:'600'}}> | {reduxCompany?.companyCode}</span> */}
        </span>



      </div>
      <nav className="main-header navbar navbar-expand navbar-dark navbar-dark">
        {/* <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item">
            <h3 className="pagetitle mb-0" id="pageTitle"></h3>
          </li>
        </ul> */}

        <ul className="navbar-nav ml-auto">

          {/* Launcher */}
          <li className="nav-item ">

            <a
              className="nav-link dropdown-toggle"
              type="button"
              data-widget="control-sidebar"
              data-controlsidebar-slide="true"
              href="#"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >

              <img src="./assets/img/logo-symbol-vishwam.png" alt="VISHWAM" class="brand-image" width="30px" height="30px" />
            </a>
            <div className="dropdown-menu dropdown-menu-right launcher">
              <div className="mb-2">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-block"
                  style={{ borderRadius: '50px', fontWeight:'600' }}
                  title="Go to Vishwam"
                  onClick={ ()=>{handleBackToVishwam(process.env.REACT_APP_VISHWAM_BASE_URL)}}
                >
                  <img src="./assets/img/logo-symbol-vishwam.png" alt="VISHWAM" width="20px" />&nbsp;&nbsp;Go to Vishwam
                </button>
              </div>
              {appsLength < 1 && <div className={`app-launcher-box mt-3 mb-3`}>
                <div className="no-app-cat"><div><Icon icon="iconoir:log-no-access" width="24" height="24" /></div>You don't have access to applications. Please contact your administrator.</div>
              </div>}
              <div className={`app-launcher-box
                  ${isApplicationAssignedAndActive(2) ||
                  isApplicationAssignedAndActive(19) ||
                  isApplicationAssignedAndActive(16) ||
                  isApplicationAssignedAndActive(3)
                  ? "" : "d-none mb-0"
                }`}>
                <div className="app-cat">Enterprise &amp; Resource Management</div>
                {/* <div className={`apps ${isApplicationAssignedAndActive(2) ? "" : "d-none"}`}
                  onClick={() => {
                    if (isApplicationAssignedAndActive(2)) {
                      handleLauncherLogin(process.env.REACT_APP_DGLINKZ_BASE_URL)
                    }
                  }}
                >
                  <div className="" title="DigiLinkZ - Document Management Software">
                    
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(2)}`} /></div>
                    <div className="app-title">DigiLinkZ</div>
                  </div>
                </div> */}
                <div className={`apps ${isApplicationAssignedAndActive(19) ? "" : "d-none"}`}
                  onClick={() => {
                    if (isApplicationAssignedAndActive(19)) {
                      handleLauncherLogin(process.env.REACT_APP_VAULTZ_BASE_URL)
                    }
                  }}
                >
                  <div className="" title="VaultZ - Fund Request & Payment Approval System">
                    {/* <div className="app-icon"><img src="./assets/img/app-vaultz.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(19)}`} /></div>
                    <div className="app-title">VaultZ</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(3) ? "" : "d-none"}`}
                  onClick={() => {
                    if (isApplicationAssignedAndActive(3)) {
                      handleLauncherLogin(process.env.REACT_APP_ASSETZ_BASE_URL)
                    }
                  }}
                >
                  <div className="" title="AssetZ - Manage Asets & Inventory">
                    {/* <div className="app-icon"><img src="./assets/img/app-assetz.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(3)}`} /></div>
                    <div className="app-title">AssetZ</div>
                  </div>

                </div>

                <div className={`apps ${isApplicationAssignedAndActive(16) ? "" : "d-none"}`}
                  onClick={() => {
                    window.open("https://vhudrws3wd01.sap.vs.local:44380/sap/bc/ui2/flp#Shell-home", "_blank");
                  }}>
                  <div className="" title="SAP - Power Your Enterprise | SAP Software And Solutions">
                    {/* <div className="app-icon"><img src="./assets/img/app-sap.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(16)}`} /></div>
                    <div className="app-title">SAP</div>
                  </div>
                </div>
              </div>


              <div className={`app-launcher-box
                                          ${isApplicationAssignedAndActive(13) ||
                  isApplicationAssignedAndActive(14) ||
                  isApplicationAssignedAndActive(15) ||
                  isApplicationAssignedAndActive(17)
                  ? "" : "d-none mb-0"
                }`}>
                <div className="app-cat">Infrastructure & Business Operations</div>
                <div className={`apps ${isApplicationAssignedAndActive(13) ? "" : "d-none"}`}>
                  <div className="" title="InnCircles - Custom-fit Construction Project Management">
                    {/* <div className="app-icon"><img src="./assets/img/app-inncircles.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(13)}`} /></div>
                    <div className="app-title">InnCircles</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(14) ? "" : "d-none"}`}>
                  <div className="" title="Hectronic - Hectronic">
                    {/* <div className="app-icon"><img src="./assets/img/app-hectronic.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(14)}`} /></div>
                    <div className="app-title">Hectronic</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(15) ? "" : "d-none"}`}>
                  <div className="" title="CCC - Centralized control for efficient operations">
                    {/* <div className="app-icon"><img src="./assets/img/app-ccc.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(15)}`} /></div>
                    <div className="app-title">CCC</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(17) ? "" : "d-none"}`}>
                  <div className="" title="DarwinBox - HR Software, New-Age HR Management Software">
                    {/* <div className="app-icon"><img src="./assets/img/app-darwin-box.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(17)}`} /></div>
                    <div className="app-title">DarwinBox</div>
                  </div>
                </div>
              </div>
              <div className={`app-launcher-box
                                          ${isApplicationAssignedAndActive(7) ||
                  isApplicationAssignedAndActive(8) ||
                  isApplicationAssignedAndActive(5) ||
                  isApplicationAssignedAndActive(12)
                  ? "" : "d-none mb-0"

                }`}>
                <div className="app-cat">Security & Safety Management</div>
                <div className={`apps ${isApplicationAssignedAndActive(7) ? "" : "d-none"}`}>
                  <div className="" title="BeatZ - Security Personnel Management">
                    {/* <div className="app-icon"><img src="./assets/img/app-beatZ.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(7)}`} /></div>
                    <div className="app-title">BeatZ</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(8) ? "" : "d-none"}`}>
                  <div className="" title="Safety Eye - Reporting Safety Issues and Ticketing">
                    {/* <div className="app-icon"><img src="./assets/img/app-safety-eye.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(8)}`} /></div>
                    <div className="app-title">Safety Eye</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(5) ? "" : "d-none"}`}>
                  <div className="" title="KwartZ - Quality Control and Assurance">
                    {/* <div className="app-icon"><img src="./assets/img/app-kwartz.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(5)}`} /></div>
                    <div className="app-title">KwartZ</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(12) ? "" : "d-none"}`}>
                  <div className="" title="SCADA System - Smart Solutions for Road Works">
                    {/* <div className="app-icon"><img src="./assets/img/app-scadasystem.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(12)}`} /></div>
                    <div className="app-title">SCADA</div>
                  </div>
                </div>
              </div>
              <div className={
                `app-launcher-box 
                                          ${isApplicationAssignedAndActive(6) ||
                  isApplicationAssignedAndActive(4) ||
                  isApplicationAssignedAndActive(10) ||
                  isApplicationAssignedAndActive(11)
                  ? ""
                  : "d-none mb-0"
                }
                                          `}>
                <div className="app-cat">Tracking & Monitoring Systems</div>
                <div className={`apps ${isApplicationAssignedAndActive(6) ? "" : "d-none"}`}>
                  <div className="" title="TrackZ - Bulk Material Tracking System">
                    {/* <div className="app-icon"><img src="./assets/img/app-trackz.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(6)}`} /></div>
                    <div className="app-title">TrackZ</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(4) ? "" : "d-none"}`}>
                  <div className="" title="WingZ - Shutters Tracking and Monitoring">
                    {/* <div className="app-icon"><img src="./assets/img/app-wingz.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(4)}`} /></div>
                    <div className="app-title">WingZ</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(10) ? "" : "d-none"}`}>
                  <div className="" title="SSTracking - Specializes in producing customized GPS solutions">
                    {/* <div className="app-icon"><img src="./assets/img/app-sstracking.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(10)}`} /></div>
                    <div className="app-title">SSTracking</div>
                  </div>
                </div>
                <div className={`apps ${isApplicationAssignedAndActive(11) ? "" : "d-none"}`}>
                  <div className="" title="KTTelematic - Helping businesses manage their fleet by making insightful decisions">
                    {/* <div className="app-icon"><img src="./assets/img/app-kttelematic.png" /></div> */}
                    <div className="app-icon"><img src={`${process.env.REACT_APP_CDN_VISHWAM_BASE_URL + getAppLogo(11)}`} /></div>
                    <div className="app-title">KTTelematic</div>
                  </div>
                </div>
              </div>
            </div>
          </li>


          <li className="nav-item">

          </li>

          <li className="nav-item">
            <a
              className="nav-link dropdown-toggle user"
              type="button"
              data-widget="control-sidebar"
              data-controlsidebar-slide="true"
              href="#"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Icon icon="tdesign:user" width="20" height="20" />&nbsp;<span className="empid">{user?.userName} ({reduxCompany?.companyCode})</span>
              {/* {user?.userName} */}
              {/* &nbsp;{user?.firstName ? user?.firstName + " " + user?.lastName : user?.userName} */}
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              {/* User Full Name */}
              <li className="nav-item" style={{ borderBottom: '1px solid silver', marginBottom: '0.3rem', paddingBottom: '0.2rem' }}>
                <span
                  className="nav-link"
                  role="button"
                >
                  {user?.firstName + " " + user?.lastName}
                </span>
              </li>
              {/* Change Company */}
              <li className="nav-item">
                <span
                  className="nav-link"
                  // data-widget="pushmenu"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    dispatch(
                      setCompany({
                        ...reduxCompany,
                        id: reduxCompany?.id || 1,
                        isChangeCompanyModalOpen: !reduxCompany?.isChangeCompanyModalOpen,
                      })
                    );
                  }}
                >
                  <i class="fas fa-exchange-alt"></i>  Switch Company
                  {/* : {reduxCompany?.id} */}
                </span>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-widget="pushmenu"
                  href="#"
                  role="button"
                  onClick={() => {
                    ClearSessionItems();
                    localStorage.clear();
                    window.location.href = "/";
                  }}
                >
                  <i className="fas fa-sign-out-alt"></i> Exit
                </a>
              </li>



            </div>
          </li>
        </ul>
      </nav>
      {reduxCompany?.isChangeCompanyModalOpen && <ChangeCompanyComponent />}
    </>
  );
}
